import React, { useContext } from "react";
import i18next from "i18next";
import { CheckoutContext } from "~/assets/js/pages/Checkout/CheckoutProvider";
import { formatMembersTimeslotEntryFromCart } from "~/assets/js/Helpers/timeslot-utils";
import { Users, Clock } from "react-feather";
import PropTypes from "prop-types";
import { subsFromDate } from "../../Helpers/date-utils";
import { MEMBER_BUFFER } from "../../global/useGroupOrder";
import moment from "moment";

const BANNER_NOT_ON_PAGES = ["login", "register"];

const GroupOrderBanner = ({ ownerName, slotEnd, isOwner = false }) => {
    const context = useContext(CheckoutContext);
    const hideBanner =
        context !== undefined &&
        BANNER_NOT_ON_PAGES.includes(context?.state?.page);

    if (hideBanner) {
        return null;
    }

    const slotToDisplay = (() => {
        if (!slotEnd) {
            return "";
        }

        // Show no buffer for the owner
        if (isOwner) {
            return formatMembersTimeslotEntryFromCart(moment(slotEnd));
        }

        const slotWithBuffer = subsFromDate({
            date: slotEnd,
            ...MEMBER_BUFFER,
        });

        return formatMembersTimeslotEntryFromCart(slotWithBuffer);
    })();

    return (
        <>
            <div className="banner">
                <Users className="banner-icon" />
                <strong>
                    {isOwner
                        ? i18next.t("ownerGroupOrder.bannerText")
                        : i18next.t("memberGroupOrder.bannerText", {
                              name: ownerName,
                          })}
                </strong>
                <div className="banner-time">
                    <Clock className="banner-time__icon" />
                    <div className="banner-time__textContainer">
                        <p className="banner-time__upperText">
                            {isOwner
                                ? i18next.t("ownerGroupOrder.bannerTimeText")
                                : i18next.t("memberGroupOrder.bannerTimeText")}
                        </p>
                        <p className="banner-time__bottomText">
                            {slotToDisplay}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

GroupOrderBanner.propTypes = {
    ownerName: PropTypes.string,
    slotEnd: PropTypes.string,
    isOwner: PropTypes.bool,
};
export default GroupOrderBanner;
